/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';
import { IParticipantes } from './InternalTraining';
import { IFrequentadores } from './Seminario';

export interface IEmergencySimulation {
    id_barragem?: string;
    periodo_referencia: string,
    data_simulado: string,
    instituicoes_participantes: string,
    participantes: IParticipantes[],
    frequentadores: IFrequentadores[],
    uuid?: string,
}

const create = async (data: IEmergencySimulation): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/simulado', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo simulado');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo simulado');
        }
    }
};

const upgrade = async (data: IEmergencySimulation, uuid: string): Promise<string | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`/simulado?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao criar novo simulado');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar novo simulado');
        }
    }
};

const list = async (uuid: string): Promise<IEmergencySimulation[] | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/simulados?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar simulado');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar simulado');
        }
    }
};

const get = async (uuid: string): Promise<IEmergencySimulation | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`/simulado?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar simulado');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao buscar simulado');
        }
    }

};

const delet = async (uuid: string): Promise<string | Error> => {

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete(`/simulado?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao listar simulado');
    } catch (error: any){
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao listar simulado');
        }
    }
};

export const EmegencySimulationsServices =  {
    create,
    list,
    get,
    delet,
    upgrade
};